interface SidebarProps {
  selectedUnit: string | null;
  onSelectUnit: (unit: string | null) => void;
  buildingTypes: BuildingType[];
  resources: { fuel: number; steel: number; ammo: number };
  onBuild: (type: string) => void;
  onUpgrade: (buildingId: string) => void;
  buildings: PlayerBuilding[];
}

interface BuildingType {
  id: string;
  name: string;
  description: string;
  icon: string;
  costSteel: number;
  costAmmo: number;
  prodFuel: number;
  prodSteel: number;
  prodAmmo: number;
  maxLevel: number;
}

interface PlayerBuilding {
  id: string;
  buildingType: string;
  level: number;
  gridX: number;
  gridY: number;
}

export default function Sidebar({ buildingTypes, resources, onBuild, buildings, onUpgrade }: SidebarProps) {
  const playerBuildings = buildings || [];

  return (
    <aside className="sidebar">
      <div className="sidebar-section">
        <h3>Ressourcen</h3>
        <div className="resources-list">
          <div className="resource-row">
            <span>⛽ Fuel</span>
            <span className="res-val">{resources.fuel}</span>
          </div>
          <div className="resource-row">
            <span>⛏️ Stahl</span>
            <span className="res-val">{resources.steel}</span>
          </div>
          <div className="resource-row">
            <span>💥 Munition</span>
            <span className="res-val">{resources.ammo}</span>
          </div>
        </div>
      </div>

      <div className="sidebar-section">
        <h3>Gebäude bauen</h3>
        <div className="build-list">
          {buildingTypes.map((bt) => (
            <button
              key={bt.id}
              className="build-btn"
              onClick={() => onBuild(bt.id)}
              disabled={resources.steel < bt.costSteel || resources.ammo < bt.costAmmo}
            >
              <span className="build-icon">{bt.icon}</span>
              <span className="build-info">
                <span className="build-name">{bt.name}</span>
                <span className="build-cost">{bt.costSteel}⚙️ {bt.costAmmo > 0 ? `${bt.costAmmo}💥` : ''}</span>
              </span>
            </button>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h3>Meine Gebäude</h3>
        <div className="build-list">
          {playerBuildings.length === 0 && (
            <div className="sidebar-placeholder">Noch keine Gebäude</div>
          )}
          {playerBuildings.map((b) => (
            <div key={b.id} className="building-item">
              <span className="building-item-info">
                <span className="building-item-name">{b.buildingType} Lv.{b.level}</span>
                <span className="building-item-pos">({b.gridX},{b.gridY})</span>
              </span>
              <button className="upgrade-btn" onClick={() => onUpgrade(b.id)}>↑</button>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}
